import { ErrorMessage as BaseErrorMessage } from 'formik';

const ErrorMessage = ({ name }) => <BaseErrorMessage name={name} component="span" className="akoconf-block akoconf-text-xs akoconf-text-ako-red" />

export default ErrorMessage;
